<template>
  <a :href="link" :target="target" class="contacts-card-link">
    <FaqAndSupportContactsCard :label="label" :text="text">
      <VIconMTS name="faq_and_support/icon-arrow" width="44" height="44" />
    </FaqAndSupportContactsCard>
  </a>
</template>

<script>
import FaqAndSupportContactsCard from '@/components/Desktop/FaqAndSupport/Contacts/FaqAndSupportContactsCard.vue'
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'

export default {
  name: 'FaqAndSupportContactsCardLink',
  components: { VIconMTS, FaqAndSupportContactsCard },
  props: {
    label: {
      type: String,
      default: '',
      required: true,
    },
    text: {
      type: String,
      default: '',
    },
    link: {
      type: String,
      default: '',
      required: true,
    },
    target: {
      type: String,
      default: '_blank',
    },
  },
}
</script>

<style scoped lang="scss">
.contacts-card-link {
  display: block;
  text-decoration: none;
  color: $color-dark;
}
</style>
